/**
 * ホームページ翻訳 - 日本語
 * Homepage translations - Japanese
 */

export default {
  hero: {
    title: 'インテリジェント·インフラ·アジア太平洋を繋ぐ',
    subtitle: '思棟株式会社は、先進的な技術ソリューションを通じて企業のデジタル変革を支援し、インテリジェントで相互接続された未来を構築することに取り組んでいます',
    cta: 'お問い合わせ',
    learnMore: '詳しく見る'
  },
  
  coreMetrics: {
    title: 'コア指標ダッシュボード',
    subtitle: '数字が語る、実力が証明する',
    systemAvailability: 'システム可用性',
    serviceRegions: 'サービス地域',
    clientsServed: 'サービス提供企業',
    certifications: '技術認証',
    highAvailability: '年間高可用性保証',
    coveringAsiaPacific: 'アジア太平洋主要市場をカバー',
    enterpriseClients: '累計サービス提供企業数',
    internationalCerts: '国際的な権威認証'
  },
  
  serviceRegions: {
    title: 'サービスカバレッジマップ',
    subtitle: 'APAC 11のサービス地域をカバー。地図ノードをクリックすると現地サービス詳細を確認できます。',
    viewAllRegions: 'すべての地域を見る'
  },
  
  certifications: {
    title: '資格認定とコンプライアンス能力',
    subtitle: '国際標準認証、多地域コンプライアンス保証',
    viewAll: 'すべての認証を見る',
    validUntil: '有効期限',
    issuedBy: '発行機関',
    categories: {
      quality: '品質管理',
      security: 'セキュリティ',
      telecom: '通信資格',
      technology: 'テクノロジーパートナー',
      privacy: 'プライバシーとコンプライアンス'
    }
  },
  
  caseStudies: {
    title: '最近の成功事例',
    subtitle: '実際の事例、実力の証',
    filterByIndustry: '業界別フィルター',
    allIndustries: 'すべての業界',
    finance: '金融',
    healthcare: '医療',
    manufacturing: '製造',
    government: '政府',
    retail: '小売',
    professional: 'プロフェッショナルサービス',
    education: '教育',
    viewAllCases: 'すべての事例を見る',
    viewDetail: '詳細を見る',
    outcome: 'プロジェクト成果',
    industry: '業界',
    region: '地域',
    noResults: '{industry} の事例はまだありません。ほかの業界をご確認ください。',
    noCases: '表示できる事例がありません。'
  },
  
  testimonials: {
    title: 'お客様の声',
    subtitle: 'お客様の評価を聞く',
    rating: '評価'
  },
  
  regionalContact: {
    title: 'お問い合わせ',
    subtitle: '11のサービス地域、いつでもサポートします',
    office: 'サービスセンター',
    phone: '電話番号',
    email: 'メールアドレス',
    businessHours: '営業時間',
    viewContactPage: '完全な連絡先情報を見る'
  },
  
  cta: {
    title: '今すぐ製品を体験',
    subtitle: '思棟株式会社は、最先端の技術ソリューションを提供することに取り組んでいます。当社の製品は、数百社の企業がデジタル変革を実現し、運用効率を向上させ、ビジネス成長を推進するのを支援してきました。',
    contact: 'お問い合わせ',
    trialNow: '無料トライアル'
  },
  
  news: {
    latest: '最新ニュース',
    industry: '業界インサイト',
    company: '会社ニュース',
    item1: {
      content: '思棟株式会社は、世界をリードするAI企業と戦略的パートナーシップを締結し、AIの新しいフロンティアを共に探求します。',
      date: '2023年10月26日'
    },
    item2: {
      content: '思棟株式会社が2024年テクノロジートレンドレポートを発表、クラウドコンピューティングとビッグデータに焦点を当てています。',
      date: '2023年10月20日'
    },
    item3: {
      content: '思棟株式会社が「年間最優秀テクノロジーイノベーション企業」賞を受賞しました。',
      date: '2023年10月15日'
    }
  },
  
  insights: {
    title: '注目のトレンドとインサイト',
    digitalTransformation: {
      title: 'デジタル変革：ビジネス成長の新しいエンジン',
      description: 'デジタル変革がビジネス環境をどのように再構築しているか、思棟株式会社が企業の効率的な変革をどのように支援しているかを深く掘り下げます。'
    },
    aiFuture: {
      title: 'AIと未来：インテリジェント時代の無限の可能性',
      description: '人工知能の最新の進歩と各業界における応用の見通しを探求し、思棟株式会社のAIソリューションを紹介します。'
    },
    bigData: {
      title: 'ビッグデータ：ビジネス価値洞察の源',
      description: 'ビッグデータが企業の意思決定をどのように支援するか、思棟株式会社が包括的なデータ分析ソリューションをどのように提供するかを探求します。'
    }
  },

  coreServices: {
    kicker: 'Service Portfolio',
    title: 'コアサービス',
    subtitle: '統一 SLA、地域横断の調整、現地デリバリーを両立し、デジタル化のライフサイクル全体にわたる信頼性の高いインフラと運用を提供します。',
    viewDetail: '詳しく見る',
    viewAllServices: 'サービス一覧',
    items: [
      {
        sectionId: 'digital-workplace',
        eyebrow: 'デジタルワークプレイス',
        title: 'デスクトップとエンドポイント体験',
        description: '端末、アカウント権限、コラボレーションツールを統合支援。入退社、リモートワーク、IT資産のライフサイクル管理まで含め、生産性と働き方体験を高めます。'
      },
      {
        sectionId: 'data-center-network',
        eyebrow: 'ネットワークとデータセンター',
        title: '企業・店舗ネットワーク',
        description: 'LAN/WAN/WiFi、スイッチ・ファイアウォールの構築・保守、データセンター／機室運用までをカバーし、ミッションクリティカルな業務の安定稼働を支えます。'
      },
      {
        sectionId: 'cloud-operations',
        eyebrow: 'クラウドとクラウド運用',
        title: 'クラウドアーキテクチャとコスト最適化',
        description: 'パブリック／ハイブリッドクラウドの設計・移行、運用とセキュリティ監視、コスト最適化により、拡張性と事業変化への追従力を高めます。'
      },
      {
        sectionId: 'retail-store-ops',
        eyebrow: '小売店舗 IT 運用',
        title: 'マルチストアの標準化デリバリー',
        description: '多国・多店舗向けの標準化運用、POS と店舗ネットワーク、新店立ち上げ、移転・アップグレードを支援し、営業への影響を最小化します。'
      }
    ]
  },

  productExtensions: {
    title: 'デジタル機能',
    subtitle: 'スマートチケットと AI 分析に加え、CRM 開発、MA、ミニプログラム、AI ナレッジベース、オフィス向けインテリジェントエージェントで、データドリブンな運用へ拡張します。',
    viewAll: '製品機能を見る',
    items: [
      {
        title: 'CRM ソフトウェア開発',
        tagline: '会員基盤とC向けユーザー運営',
        description: 'ブランドの C 向けユーザー管理に向けて、会員情報、タグ、ポイント特典、接点運営、再購入促進を備えた会員 CRM を構築します。'
      },
      {
        title: 'MA マーケティングオートメーション',
        tagline: '自動接点と成果拡大',
        description: 'Web、CRM、メール、メッセージ配信をつなぎ、リード育成を自動化します。'
      },
      {
        title: 'ミニプログラム開発',
        tagline: '軽量なサービス導線',
        description: '予約、修理受付、照会、会員サービス向けのミニプログラムを開発します。'
      },
      {
        title: 'AI ナレッジベース',
        tagline: '知識蓄積と Q&A',
        description: 'FAQ、SOP、対応履歴、製品資料を統合し、意味検索と権限管理に対応します。'
      },
      {
        title: 'オフィス向けインテリジェントエージェント',
        tagline: 'オフィス業務の自動化',
        description: 'メール、承認、会議メモ、タスク連携、ナレッジ検索を通じて社内協業を高めます。'
      }
    ]
  },
  
  mission: {
    title: '私たちの使命',
    description: '思棟株式会社は、世界をリードするテクノロジーサービスプロバイダーになることを目指しています。継続的なイノベーションと優れたサービスを通じて、お客様がビジネスの成長とデジタル変革を実現し、よりインテリジェントで相互接続された未来を共に構築することを支援します。私たちはテクノロジーの力を信じ、それを原動力として社会に価値を創造します。'
  },
  
  expertise: {
    title: '私たちの専門分野',
    bigData: {
      title: 'ビッグデータと分析',
      description: 'データ収集から深層分析まで、企業が膨大なデータから価値を発掘し、インテリジェントな意思決定を推進することを支援します。'
    },
    ai: {
      title: '人工知能と機械学習',
      description: '自然言語処理、コンピュータービジョン、インテリジェントオートメーションを含むカスタマイズされたAIソリューションを開発および展開します。'
    },
    itConsulting: {
      title: 'ITコンサルティングと管理',
      description: '戦略的ITコンサルティング、プロジェクト管理、IT運用の最適化を提供し、技術投資がビジネス目標と一致することを保証します。'
    }
  },
  
  services: {
    title: '私たちのサービス',
    ticketSystem: {
      title: 'スマートチケットシステム',
      subtitle: 'サービスリクエストと問題を効率的に管理',
      description: '当社のスマートチケットシステムは、提出から解決までのサービスリクエストプロセスを合理化し、完全な可視化を実現します。チケットのステータスをリアルタイムで追跡し、処理の進捗を把握し、技術チームとシームレスにコミュニケーションできます。',
      features: {
        realTimeTracking: 'リアルタイムステータス追跡',
        multiChannel: 'マルチチャネル提出',
        smartAssignment: 'スマート割り当て',
        historyQuery: '履歴クエリ'
      },
      progressTitle: 'チケット処理進捗の例'
    },
    aiSolutions: {
      title: 'AI駆動ソリューション',
      subtitle: '人工知能を活用してビジネスの成長を推進',
      description: '最先端の人工知能技術をビジネスプロセスに統合し、インテリジェントカスタマーサービス、データ予測、自動化された意思決定などを含むカスタマイズされたAIソリューションを提供し、効率を向上させ、ユーザー体験を最適化します。',
      features: {
        chatbot: 'インテリジェントチャットボット',
        biAnalytics: 'ビジネスインテリジェンス分析',
        recommendation: 'パーソナライズされた推奨',
        security: 'インテリジェントセキュリティ保護'
      },
      ctaButton: 'AIソリューションを見る'
    }
  }
}
